export default "__VITE_ASSET__39933d7d__"